import { createStore } from 'vuex'
import localStorage from '@/plugins/localStorage'
import connection from "@/store/connection";
import user from "@/store/user";
import connectionStorage from '@/plugins/connectionStorage'

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import ws from "@/plugins/websocket";

import { AxiosError } from 'axios';

export default createStore({
  modules: {
    connection: connection,
    user: user,
  },
  state: {
    //тема
    theme: "",
    //включить звуковые уведодмления
    soundNotifications: false,

    online: true,
    //настройки клиента
    clientSettings: false,
    //ИД соединения вебсокета
    websocketId: "",
  },
  getters: {
    
    getTheme(state) {
      return state.theme;
    },
    getSoundNotifications(state){
      return state.soundNotifications;
    },
    getOnline(state) {
      return state.online;
    },
    getWebSocketId(state) {
      return state.websocketId;
    },

    /**
     * Настройки клиента
     */
    getClientSettings(state) {
      return state.clientSettings;
    },
    
  },
  mutations: {
    
    setTheme: (state, value) => {
      state.theme = value;
      localStorage.set("theme", value);
    },
    setSoundNotifications: (state, value) => {
      state.soundNotifications = value;
      localStorage.set("soundNotifications", value);
    },
    
    setOnline: (state, value) => {
      state.online = value;
    },
    
    setWebSocketId: (state, value) => {
      state.websocketId = value;
    },

    setClientSettings: (state, value) => {
      state.clientSettings = value;
    },

  },
  actions: {
    

    /**
     * Сброс данных
     */
    clear(context) {

      //очищаем подключения
      connectionStorage.setConnections({});
      connectionStorage.setCurrentConnection(0);
      localStorage.set("connections", {});

      //сбрасываем состояние, зависящее от текущего аккаунта
      context.dispatch("reset");
    },

    /**
     * Сброс данных, зависящий от аккаунта
     */
    reset(context) {

      //сброс профиля пользователя
      context.commit('setUserProfile', false);
      //сброс настроек клиента
      context.commit('setClientSettings', false);

    },

    /**
     * Загружает настройки клиента
     */
    loadClientSettings(context) {

      return new Promise((resolve,reject) => {

        //запрашиваем данные
        rest
          .call("system.settings", {}, false)
          .then((data) => {
            if (data.success) {
              context.commit('setClientSettings', data.settings);
            } else {
              //показываем сообщение об ошибке
              bus.emit("SBS_MESSAGE_E_SHOW", { message: data.errorText });
              reject(new Error(data.errorText));
            }
            resolve();
        }).catch(error => {

          if(error instanceof AxiosError) {
            if(error.code == "ECONNABORTED") {
              bus.emit("SBS_MESSAGE_E_SHOW", { message: "Превышено время ожидания, пропробуйте перезагрузить приложение." });
              reject(new Error("Превышено время ожидания, пропробуйте перезагрузить приложение."));
            }
          }

          bus.emit("SBS_MESSAGE_E_SHOW", { message: error.message });
          reject(error);

        });
        
      });
      
    },

    /**
     * Выход (сброс данных об авторизации)
     * @param {*} context 
     */
    logout(context) {

        //закрываем подключение по вебсокету
        ws.close();
        //очищаем хранилище
        localStorage.clear();

        //сбрасываем подключения
        context.dispatch("clear");
        
        //сбрасываем состояние, зависящее от текущего аккаунта
        context.dispatch("reset");

        //сообщаем приложению о выходе, чтобы оно могла перенаправить пользователя на экран входа
        bus.emit("SBS_APP_E_LOGOUT");

    },

  }

})
